// ==================== ACCOUNT NOTICE ====================
// Multiple organizations: shown under the header when something is created while
// "All Accounts" is chosen, asking for a specific account (same alert design as the
// rest of the app).

import { useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertCircle, X } from 'lucide-react';
import { useOrganizations } from '../../hooks/useOrganizations';

export const AccountNotice = () => {
  const { accountNotice, dismissAccountNotice } = useOrganizations();
  const noticeRef = useRef<HTMLDivElement>(null);

  // Make sure it is seen, also when the screen was scrolled down
  useEffect(() => {
    if (accountNotice) noticeRef.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }, [accountNotice]);

  return (
    <AnimatePresence>
      {accountNotice && (
        <motion.div
          ref={noticeRef}
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          className="scroll-mt-20 mb-4 flex items-center gap-3 p-4 rounded-xl bg-(--color-warning)/10 border border-(--color-warning)/30"
        >
          <AlertCircle size={20} className="text-(--color-warning) shrink-0" />
          <p className="text-sm text-(--color-warning) flex-1">{accountNotice}</p>
          <button onClick={dismissAccountNotice} className="text-(--color-warning) hover:opacity-80">
            <X className="w-4 h-4" />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
